module.exports = __webpack_public_path__ + "media/images/facebook-cd6a1bdc770c85082d59a916bf3e9816.svg";